import { useAppSelector } from '@redux/hooks';
import { useEffect, useRef } from 'react';
import { orderRecentlySeenVendors } from '../helpers/recentlyViewedVendors';

export const useOrderRecentlySeenVendors = () => {
	const rawId = useAppSelector((state) => state.vendor.vendorRaw?.id as string);
	const conversations = useAppSelector(
		(state) => state.messagedVendors.conversations,
	);
	const conversation = conversations[rawId];
	const conversationRef = useRef(conversation);
	const isLeadSent = !!conversation;
	const markedAsFavorite = useAppSelector(
		(state) => state.favorites.filled as boolean,
	);
	const categoryCode = useAppSelector(
		(state) => state.vendor.vendor?.categoryCode,
	);

	// biome-ignore lint/correctness/useExhaustiveDependencies: onMount
	useEffect(() => {
		orderRecentlySeenVendors(rawId, isLeadSent, markedAsFavorite, categoryCode);
	}, []);

	useEffect(() => {
		orderRecentlySeenVendors(rawId, isLeadSent, markedAsFavorite, categoryCode);

		if (conversation !== conversationRef.current) {
			conversationRef.current = conversation;
		}
	}, [conversation, isLeadSent, rawId, markedAsFavorite, categoryCode]);
};
